import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private zone: NgZone, private router: Router) {}

  handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      this.zone.run(() => {
        if (error.status === 401) {
          this.router.navigate(['/auth']);
        }
      });
      console.error(`HTTP Error ${error.status}:`, error.message);
    } else {
      console.error('Unexpected error:', error);
    }
  }
}
